<app-layout>
  <div *ngIf="teklif">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              Talep Bilgileri
            </h3>
            <!-- <div class="card-actions" *ngIf="isAuthenticated">
              <div class="clickable" (click)="talepDuzenle()">
                Düzenle
                <svg xmlns="http://www.w3.org/2000/svg" class="icon ml-1" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"></path>
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"></path>
                  <line x1="16" y1="5" x2="19" y2="8"></line>
                </svg>
              </div>
            </div> -->
          </div>
          <div class="card-body">
            <app-talep-detay [source]="teklif?.talep" [source3]="teklif.teslimYeri.aciklama"></app-talep-detay>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              Teklif Bilgileri
            </h3>
            <div class="card-actions" *ngIf="isAuthenticated">
              <div class="clickable" *ngIf="teklif.durum === DURUM_INITIAL" (click)="teklifGir()">
                Teklif Gir
                <svg xmlns="http://www.w3.org/2000/svg" class="icon ml-1" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"></path>
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"></path>
                  <line x1="16" y1="5" x2="19" y2="8"></line>
                </svg>
              </div>
              <div class="clickable" *ngIf="teklif.durum === DURUM_CEVAPLANDI" (click)="teklifDuzenle()">
                Revize Et
                <svg xmlns="http://www.w3.org/2000/svg" class="icon ml-1" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"></path>
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"></path>
                  <line x1="16" y1="5" x2="19" y2="8"></line>
                </svg>
              </div>
            </div>
          </div>
          <div class="card-body">
            <dl class="row">
              <dt class="col-5">Durum:</dt>
              <dd class="col-7">{{teklif.durumText}}</dd>
              <dt class="col-5">Cari:</dt>
              <dd class="col-7">{{teklif.cari?.cariKodu}} {{teklif.cari?.firmaUnvani}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="currentAction!==ACTION_INCELE || teklif.durum !== DURUM_INITIAL">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Sipariş Kalemleri</h3>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">Stok Kodu</th>
                  <th>Stok Adı</th>
                  <th>Ölçü Birimi</th>
                  <th>Talep Edilen Miktar</th>
                  <th>Firma Teklifi (Birim Fiyatı)</th>
                  <th>Para Birimi</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let k of kalemler;let i=index;">
                  <td><span class="text-muted">{{k?.stokKodu}}</span></td>
                  <td>{{k?.stokAdi}}</td>
                  <td>{{k?.olcuBirimi}}</td>
                  <td>{{k?.talepKalem.talepEdilen}}</td>
                  <td><input type="number" class="form-control" [(ngModel)]="k.tutar" (change)="toplamTutarHesapla()"
                      [readOnly]="currentAction===ACTION_INCELE"></td>
                  <td>
                    <app-loading-input *ngIf="paraBirimleri==null"></app-loading-input>
                    <select *ngIf="paraBirimleri" class="form-control" [(ngModel)]="k.paraBirimiId"
                      (change)="toplamTutarHesapla()" [ngModelOptions]="{standalone: true}"
                      [disabled]="currentAction===ACTION_INCELE">
                      <option [value]="null" disabled selected>Şeçiniz</option>
                      <option *ngFor="let p of paraBirimleri" [ngValue]="p.id">{{p.aciklama}}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right">
            <b>Teklif Toplamı:</b> {{totalTutarText}}
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="currentAction!==ACTION_INCELE || teklif.durum !== DURUM_INITIAL">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Teklif Detaylar</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Teslim Yeri</div>
                  <app-loading-input *ngIf="teslimYerleri==null"></app-loading-input>
                  <select *ngIf="teslimYerleri" class="form-control" [(ngModel)]="teklif.teslimYeriId"
                    [ngModelOptions]="{standalone: true}" [disabled]="currentAction===ACTION_INCELE">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of teslimYerleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Teslim Şekli</div>
                  <app-loading-input *ngIf="teslimSekilleri==null"></app-loading-input>
                  <select *ngIf="teslimSekilleri" class="form-control" [(ngModel)]="teklif.teslimSekliId"
                    [ngModelOptions]="{standalone: true}" [disabled]="currentAction===ACTION_INCELE">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of teslimSekilleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <div class="form-label">Ödeme Yöntemi</div>
                  <label type="text" class="form-control" *ngIf="teklif.cari?.vadeGunu === null else elseBlock">
                    VADE TANIMLI DEĞİL
                  </label>
                  <ng-template #elseBlock>
                    <label class="form-control" *ngIf="teklif.cari?.vadeGunu === '0' else elseBlock2">PEŞİN</label>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <label class="form-control">{{teklif.cari?.vadeGunu}} GÜN VADELİ</label>
                  </ng-template>
                  <!-- <app-loading-input *ngIf="odemeYontemleri==null"></app-loading-input>
                  <select *ngIf="odemeYontemleri" class="form-control" [(ngModel)]="teklif.odemeYontemiId"
                          [ngModelOptions]="{standalone: true}" [disabled]="currentAction===ACTION_INCELE">
                    <option [value]="null" disabled selected>Şeçiniz</option>
                    <option *ngFor="let p of odemeYontemleri" [ngValue]="p.id">{{p.aciklama}}</option>
                  </select> -->
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Teslim Süresi (Gün)</label>
                  <div class="input-icon">
                    <input type="number" class="form-control" [(ngModel)]="teklif.teslimSuresi"
                      [disabled]="currentAction===ACTION_INCELE">
                    <!-- <input
                      *ngIf="currentAction!==ACTION_INCELE"
                      mwlFlatpickr
                      class="form-control mb-2 flatpickr-input"
                      type="text"
                      placeholder="Teslim Tarihi"
                      [(ngModel)]="teklif.teslimTarihi"
                      [altInput]="true"
                      [convertModelValue]="true">
                    <input
                      *ngIf="currentAction===ACTION_INCELE"
                      class="form-control mb-2"
                      type="text"
                      placeholder="Teslim Tarihi"
                      [readOnly]="true"
                      [value]="teklif.teslimTarihiText"> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="mb-3">
                  <div class="form-label">Opsiyon</div>
                  <textarea class="form-control" rows="2" placeholder="Opsiyon" [(ngModel)]="teklif.opsiyon"
                    [readOnly]="currentAction===ACTION_INCELE"></textarea>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="mb-3">
                  <div class="form-label">Garanti Süresi</div>
                  <textarea class="form-control" rows="2" placeholder="Garanti Süresi"
                    [(ngModel)]="teklif.garantiSuresi" [readOnly]="currentAction===ACTION_INCELE"></textarea>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="mb-3">
                  <div class="form-label">Firma Teklif Notu</div>
                  <textarea class="form-control" rows="2" placeholder="Firma Teklif Notu"
                    [(ngModel)]="teklif.firmaTeklifNotu" [readOnly]="currentAction===ACTION_INCELE"></textarea>
                </div>
              </div>

              <div class="col-md-12 col-lg-12">
                <div class="mb-3">
                  <div class="row row-sm">
                    <div class="col-6 col-sm-3 attachment" *ngFor="let g of teklif.teklifGorseller;let index = i">
                      <div class="container">
                        <img [src]="g.getUri()" alt="" class="image" style="width:100%">
                        <div class="middle">
                          <div class="card-body">
                            <div class="d-flex align-items-center">
                              <div class="ml-auto">
                                <a class="text clickable" (click)="downloadFile(g.dosya)">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24"
                                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                    <polyline points="7 11 12 16 17 11"></polyline>
                                    <line x1="12" y1="4" x2="12" y2="16"></line>
                                  </svg>
                                  Görüntüle
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer d-flex align-items-center">
            <div class="row">
              <ul class="m-0 text-right">
                <button class="btn btn-success" (click)="teklifKaydet()"
                  [disabled]="currentAction===ACTION_INCELE">Teklifi Kaydet</button>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</app-layout>